import React from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import CrudContact from './CrudContact'

const ContactPage = () => {
    const { t } = useTranslation()

    return (
        <CMS>
            <PageBanner
                title={t("contact_management")}
                description={t("contact_management_desc")}
            />

            <CrudContact />
        </CMS>
    )
}

export default ContactPage
